module.exports = __webpack_public_path__ + "static/cuadro_icon.0e8dbf49.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/cuadro_icon.png
// module id = 430
// module chunks = 35783957827783